export enum ParticipantType {
  AGENT = 'AGENT',
  EXTERNAL = 'EXTERNAL',
  THIRD_PARTY = 'THIRD_PARTY',
}

export class Participant {
  constructor(
    public legId: string,
    public state: string,
    public type: ParticipantType,
    public isOnHold: boolean,
    public phoneNumber?: string,
  ) {}
}

export class InactiveParticipant {
  constructor(
    public legId: string,
    public state: string,
    public type: ParticipantType,
    public isOnHold: boolean,
    public phoneNumber?: string,
  ) {}
}
